export default __webpack_public_path__ + "static/media/spam.342ec3ac.svg";